import { render } from "./PosterNow.vue?vue&type=template&id=23bc8c18"
import script from "./PosterNow.vue?vue&type=script&lang=js"
export * from "./PosterNow.vue?vue&type=script&lang=js"

import exportComponent from "D:\\main\\spacelab\\cinema-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__